import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=11b15219"
import script from "./RoleCard.vue?vue&type=script&lang=ts"
export * from "./RoleCard.vue?vue&type=script&lang=ts"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=11b15219&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports